import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncComponentError = ({
  retry
}) => {
  return /*#__PURE__*/_jsxs(UIErrorMessage, {
    title: I18n.text('conversations-inbox-ui.code-splitting.error.title'),
    illustrationProps: {
      width: '100'
    },
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-ui.code-splitting.error.message"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "xs",
      onClick: retry,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-ui.code-splitting.error.button"
      })
    })]
  });
};
AsyncComponentError.displayName = 'AsyncComponentError';
export default AsyncComponentError;